import config from './config';
import initForm from '../../bootstrap';

initForm(config);
